// frontend/src/components/account/CancelSubscriptionModal.jsx
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const CancelSubscriptionModal = ({
  cancelModal,
  setCancelModal,
  confirmCancelSubscription,
  isLoading,
}) => {
  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />
          <span>Cancel Subscription</span>
        </div>
      }
      open={cancelModal}
      onOk={confirmCancelSubscription}
      onCancel={() => setCancelModal(false)}
      okText="Yes, Cancel at Period End"
      cancelText="Keep Subscription"
      confirmLoading={isLoading}
      okButtonProps={{ danger: true, style: { borderRadius: "6px" } }}
      cancelButtonProps={{ style: { borderRadius: "6px" } }}
    >
      <p>
        Are you sure you want to cancel? You will keep access until the end of
        your current billing period. You can choose Keep plan before that date
        if you change your mind.
      </p>
    </Modal>
  );
};

export default CancelSubscriptionModal;
